import styled from 'styled-components';
import { Modal } from '@perch-labs/shrike';
import SVG from 'react-inlinesvg';

export const ReactivatePlanModalHeader = styled(Modal.Header)`
  padding: 13px, 8px, 13px, 8px;
`;

export const MoversSubModal = styled.div`
  padding: 16px;
  margin-top: 16px;
  margin-bottom: 32px;
  border-radius: 8px;
  background: var(--background-secondary, #f7fafa);
`;

export const SVGHolder = styled(SVG).attrs({
  height: '32px',
  width: '32px',
})``;
